<page-content>
    <header-elitment header></header-elitment>
    <side-menu left-menu>
    </side-menu>
    <div class="cards-container">
        <organizations-organization-member-card *ngFor="let member of membersData"
                                                [organization]="member.organization"
                                                [user]="member.user"
                                                [roles]="member.roles">
        </organizations-organization-member-card>
    </div>
    <footer-elitment footer></footer-elitment>
</page-content>
